import { render, staticRenderFns } from "./UpgradeToPro.vue?vue&type=template&id=34eb7d04&"
import script from "./UpgradeToPro.vue?vue&type=script&lang=ts&"
export * from "./UpgradeToPro.vue?vue&type=script&lang=ts&"
import style0 from "./UpgradeToPro.vue?vue&type=style&index=0&id=34eb7d04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports